var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-row middle box",staticStyle:{"background-color":"#f7f7f7"}},[_c('div',{staticClass:"flex-row start middle"},[_c('div',{staticStyle:{"color":"#333","font-weight":"700","font-size":"18px"}},[_vm._v(" "+_vm._s(_vm.title)+" ")])]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }